export default class Security {
    getErrorMessage(error:any) {
        if (error?.response!==undefined) {      
            if (error.response.status === 400) {    //self-defined error message from backend
                return (error.response.data.error?.message) ? error.response.data.error.message : error.response.data.errors;
            } else if (error.response.status === 401) {  //not login yet - throw to login page
                return 'Please login first.';
            } else if (error.response.status === 403) {  //no permission
                return 'You have no permission to perform the action.';
            } else if (error.response.status === 408) {  //timeout
                return 'Timeout in backend server processing. Please try again in a few minutes.';
            } else if (('' + error).toLowerCase().indexOf('network error') >= 0
            || ('' + error).toLowerCase().indexOf('timeout') >= 0) {                
                return 'Failure in connecting to the server. Please try again in a few minutes.';
            } else{
                return 'Failure in connecting to the server. Please try again in a few minutes.';
            }           
        }else{
            return "Failure in connecting backend server. Please try again in a few minutes.";
        }
    }
}